export const PROPS = {
    layers: {},
    data: {},
    globalConfig: {}
};
